module.exports = __webpack_public_path__ + "static/media/sugerido.be10601c.svg";